// Dinheiro no Balcão/Totem (pedido do dono, 29/09/2026: "ao selecionar ele deve
// já perguntar qual o valor que o cliente pagou, igual funciona na mesa"). É o
// mesmo TrocoModal da Mesa: "Valor recebido" digitado da direita para a
// esquerda (começa pelo centavo), "Valor exato", troco na hora, Enter confirma.
// Recebido = total → sem troco; maior → troco (o pedido grava troco_valor =
// recebido, como antes). Cancelar desmarca o Dinheiro.
import { useRef } from "react";

import TrocoModal from "../../../components/TrocoModal";

export default function DialogTroco({ ctx }) {
  const { totalAPagar, showChangeDialog, setShowChangeDialog, setNeedsChange, setChangeAmount, setPaymentMethod, splitPayment } = ctx;
  const confirmou = useRef(false);
  const confirmar = (recebido) => {
    confirmou.current = true;
    const precisa = parseFloat(recebido) > totalAPagar + 0.005;
    setNeedsChange(precisa);
    setChangeAmount(precisa ? recebido : "");
  };
  const aoMudar = (aberto) => {
    if (aberto) return;
    setShowChangeDialog(false);
    // Fechou sem confirmar (Cancelar/Esc): o Dinheiro fica desmarcado.
    if (!confirmou.current) setPaymentMethod(null);
    confirmou.current = false;
  };
  return (
    <TrocoModal open={showChangeDialog && !splitPayment} onOpenChange={aoMudar} total={totalAPagar} onConfirm={confirmar} />
  );
}
